/**
 * Utility to handle Web Notifications API safely.
 * Uses Service Worker registration for background-capable notifications.
 */
export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.warn("This browser does not support desktop notification");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission !== "denied") {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  }

  return false;
};

export const sendNotification = async (title, body) => {
  if (!("Notification" in window) || Notification.permission !== "granted") return;

  const options = {
    body,
    icon: "/logo192.png",
    badge: "/logo192.png",
    silent: false,
    tag: title, // Prevents duplicate notifications with the same title
    renotify: true,
  };

  try {
    // Use Service Worker for background-capable notifications when one is
    // registered. getRegistration() resolves immediately (unlike .ready, which
    // hangs forever if no service worker is registered)
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        await registration.showNotification(title, options);
        return;
      }
    }
    new Notification(title, options);
  } catch (err) {
    console.error("Failed to send notification:", err);
  }
};

